import { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useConsent } from '../../context/ConsentContext';
import { syncSignedInHint, tokenExpiresAt } from '../../utils/signedInHint';

function storedToken(): string | null {
    try {
        return localStorage.getItem('token');
    } catch {
        return null;
    }
}

/**
 * Keeps the landing site's "signed in" cookie in step with the session and the
 * preferences consent (see utils/signedInHint.ts). Renders nothing; must sit
 * inside both AuthProvider and ConsentProvider.
 */
const SignedInHint = () => {
    const auth = useAuth();
    const { consent } = useConsent();
    const isLoading = auth?.isLoading ?? true;
    const signedIn = !!auth?.user;

    useEffect(() => {
        // Wait for the stored session to be validated: a dead token restored from
        // localStorage would otherwise set the hint for a moment.
        if (isLoading) return;
        syncSignedInHint(signedIn, consent.preferences, document, signedIn ? tokenExpiresAt(storedToken()) : null);
    }, [isLoading, signedIn, consent.preferences]);

    return null;
};

export default SignedInHint;
